import type { StockQuantity } from '../types';

function isSingleStock(
    stocks: StockQuantity | StockQuantity[]
): stocks is StockQuantity {
    return !Array.isArray(stocks);
}

export default isSingleStock;
